import {connect} from 'react-redux';
import {ProtocolView as Component} from './ProtocolView';
//import {fetchProtocolScene} from '@learningblocks/protocol-constants/lib/Utilities';

import {
  setModal,
  showModal,
  setPopupFired,
  setHeldObject,
  setTargetList,
  pushInteractions,
  setLastDrop,
  setSceneScale,
  setUserScale,
  setupProtocolScene,
  setTaskPages
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state) {
  return {
    heldObject: state.notebook.protocolSection.scene.heldObject,
    targetList: state.notebook.protocolSection.scene.targetList,
    interactions: state.notebook.protocolSection.scene.interactions,

    undoAttempts: (state.notebook.protocolSection.scene.hasOwnProperty("undo"))?state.notebook.protocolSection.scene.undo.attempts:0,
    modalDisplay: (state.notebook.protocolSection.scene.hasOwnProperty("modal"))?state.notebook.protocolSection.scene.modal.display:false,

    currentSection: state.notebook.currentSection,
    currentPage: state.notebook.protocolSection.scene.currentProtocolPage,
    focusedTask: state.notebook.protocolSection.scene.focusedTask,
    focusedPage: state.notebook.protocolSection.scene.focusedPage,
    focusedTaskObj: state.notebook.protocolSection.scene.focusedTaskObj,

    solutions: (state.notebook.protocolSection.scene.hasOwnProperty('apparatus'))?state.notebook.protocolSection.scene.apparatus.solutions:null,

    drawerOpen: !state.notebook.notebookCollapsed,
    title: state.notebook.protocolSection.pageTitle,
    sceneType: state.notebook.protocolSection.currentSlide,
    apparatus: state.notebook.protocolSection.apparatus,
    sequence: state.notebook.protocolSection.sequence,
    //description: getSlideDescription(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setModal: (data) => {
      dispatch(setModal(data))
    },
    showModal: (data) => {
      dispatch(showModal(data))
    },
    setPopupFired: (data) => {
      dispatch(setPopupFired(data))
    },
    setHeldObject: (data) => {
      dispatch(setHeldObject(data))
    },
    setTargetList: (data) => {
      dispatch(setTargetList(data))
    },
    pushInteractions: (data) => {
      dispatch(pushInteractions(data))
    },
    setLastDrop: (data) => {
      dispatch(setLastDrop(data))
    },
    setSceneScale: (data) => {
      dispatch(setSceneScale(data))
    },
    setUserScale: (data) => {
      dispatch(setUserScale(data))
    },
    setupProtocolScene: (data) => {
      dispatch(setupProtocolScene(data))
    },
    setTaskPages: (data) => {
      dispatch(setTaskPages(data))
    }
  };
}

export const ProtocolView = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);

//const getProtocolSection = ({notebook}) => notebook.protocolSection;
// const getSlideDescription = createSelector(
//   [getProtocolSection],
//   (protocolSection) => {
//     const currentSlide = fetchProtocolScene(
//       protocolSection.allSlides,
//       protocolSection.currentSlide
//     );
//     return currentSlide.description;
//   }
// );
